import { registerPlugin } from '@capacitor/core';
const WelcomeSound = registerPlugin('WelcomeSound', {
    web: () => import('./web').then(m => new m.WelcomeSoundWeb()),
});
export * from './definitions';
export { WelcomeSound };
//# sourceMappingURL=index.js.map